import React from 'react';

function EditCourse() {
	return <div>EditCourse</div>;
}

export default EditCourse;
